<template>
  <v-app>
    <!--INDICA LA PÁGINA EN LA QUE SE ENCUETRA-->
    <v-card class="grlCardInfo">
      <v-breadcrumbs :items="obtRuta" class="grlClase">
        <template v-slot:item="{ item }">
          <v-breadcrumbs-item @click="insertarRuta(item.ruta)" :disabled="item.disabled">
            {{ item.text.toUpperCase() }}
          </v-breadcrumbs-item>
        </template>
      </v-breadcrumbs>
    </v-card>
    <!--IMAGEN Y TITULO DE LA PÁGINA-->
    <v-card>
      <v-img :src="imgTitle" class="grlCardImg">
        <div class="grlCardInfo">
          <h1 class="my-auto hidden-sm-and-down">Convenios</h1>
        </div>
      </v-img>
    </v-card>
    <!---->
    <div class="gralMargenes" id="gralEspaciado">
      <hr />
      <h4 class="gralTitulosLic">Descripción</h4>
      <p style="text-align: justify" class="p-2">
        La FAZ UJED parte fundamental del desarrollo regional de La Comarca
        Lagunera de los Estado de Durango y Coahuila.
        <br />
        <br />
        El proceso de globalización demanda la modernización del sector
        agropecuario mexicano, en aspectos como lo son el incremento de La
        producción de alimentos y el cuidado del medio ambiente, para ello La
        Facultad de Agricultura y Zootecnia de La Universidad Juárez del Estado
        de Durango actualmente trabaja en desarrollar un programa de
        vinculación. <br />
        <br />
        La localización geográfica de La FAZ, nos permite interactuar tanto con
        productores agropecuarios del sector social como con grandes empresas
        ganaderas, avícolas y agrícolas. <br />
        <br />
        La interacción de La FAZ no se limita al Sector Empresarial, si no que
        busca ser un ente que promueva la interacción oportuna y continua al
        mismo nivel con el sector Gubernamental. <br />
        <br />
        Nuestros alumnos de licenciatura de las especialidades Fitotecnia y
        Zootecnia efectúan visitas, prácticas y estancias profesionales en
        empresas agropecuarios líderes, con el fin de conocer La filosofía
        propia, La mecánica operativa y administrativa. Y así descubrir su nicho
        de oportunidades acorde a sus intereses y capacidades. <br />
        <br />
        Nuestros estudiantes de postgrado al igual que en licenciatura efectúan
        visitas, prácticas y estancias profesionales en empresas agropecuarios
        líderes y en proceso de crecieminto, con un enfoque diferente, con base
        ayuda de la herramientas del conocimiento que como científicos en
        formación reciben día a día, buscan determinar cómo se puede mejor la
        operación de estas empresas; ya sea incrementando la producción,
        reduciendo costos de producción o reduciendo el impacto sobre el medio
        ambiente que la actividad agrícola y pecuaria genera. <br />
        <br />
        La tecnología es cambiante y hacer agricultura hoy con herramientas como
        son GPS, Internet permite optimizar recursos y minimizar ineficiencias.
        <br />
        <br />
        La facultad de Agricultura y Zootecnia de la UJED tiene establecidos
        convenios y acuerdos de trabajo o colaboración con empresas, gobiernos,
        instituciones de educación y organizaciones de productores, con el fin
        de colaborar con el desarrollo regional y lograr la pertinencia de
        nuestros programas educativos, al evolucionar a la par de los sectores
        productivos y políticas públicas que norman a las distintas actividades
        del sector agropecuario en el Estado de Durango y Coahuila, y en la
        republica mexicana. <br />
        <br />
        <br />
        <br />
      </p>
      <v-card elevation="10" class="p-2">
        <h4 class="gralTitulosLic">
          Convenios establecidos con el sector de productos y servicios:
        </h4>

        <ul>
          <li>Asociación Nacional de Productores de Melón A.C.</li>
          <li>Hortalizas de la Laguna S.A.</li>
          <li>Semillas Berentsen S.A.</li>
          <li>Biodesert.</li>
          <li>Fondo Metropolitano de la Laguna.</li>
          <li>SuKarne.</li>
        </ul>
      </v-card>
      <br />
      <v-card elevation="10" class="p-2">
        <h4 class="gralTitulosLic">
          Convenios establecidos con sector Gobierno:
        </h4>
        <ul>
          <li>I.N.I.F.A.P.</li>
          <li>CE.N.Y.D – R.A.S.P.A.</li>
          <li>Municipio de Gómez Palacio, Dgo.</li>
          <li>F.I.R.C.O.</li>
          <li>C.N.A.</li>
          <li>S.A.G.A.D.E.R. / Forraje Verde Hidropónico.</li>
          <li>SEMARNAT.</li>
          <li>COMITÉ DE SANIDAD VEGETAL en la Comarca Lagunera.</li>
          <li>Municipio de Lerdo, Dgo.</li>
          <li>Servicio Nacional del Empleo.</li>
        </ul>
      </v-card>
      <br />
      <v-card elevation="10" class="p-2">
        <h4 class="gralTitulosLic">
          Convenios establecidos con sector educativo en México:
        </h4>
        <ul>
          <li>Instituto Tecnológico de Torreón.</li>
          <li>C.E.N.E.V.A.L.</li>
          <li>CE.C.Y.T. # 10.</li>
          <li>CE.B.E.T.A # 217.</li>
          <li>U.A.N.L.</li>
          <li>Instituto Tecnológico Superior de Santiago Papasquiaro.</li>
          <li>Universidad Autónoma de Ciudad Juárez.</li>
          <li>CO.BA.ED #4.</li>
        </ul>
      </v-card>
      <br />
      <v-card elevation="10" class="p-2">
        <h4 class="gralTitulosLic">
          Convenios en proceso:
        </h4>
        <ul>
          <li>CE.BE.TA # 167 Fresnillo Zacatecas.</li>
          <li>Grupo Tricio Haro.</li>
          <li>Grupo Rancho Lucero.</li>
          <li>Grupo LALA.</li>
          <li>Grupo alpura.</li>
          <li>Grupo Danone.</li>
          <li>Grupo Nestle.</li>
          <li>New Mexico State University.</li>
        </ul>
      </v-card>
      <br />
      <hr />
    </div>
  </v-app>
</template>
<script>

export default {
  data: () => ({
    imgTitle: require('../../assets/img/banner-OE.jpg'),
    obtRuta: [
      {
        text: 'Inicio',
        disabled: false,
        ruta: '/',
      },
      {
        text: 'Vinculación',
        disabled: true,
        ruta: '/',
      },
      {
        text: 'Convenios',
        disabled: true,
        ruta: '/',
      },
    ],
  }),
  methods: {
    insertarRuta(ruta) {
      this.$router.push(ruta);
    },
  },
};
</script>
